import { render, staticRenderFns } from "./releaseCase.vue?vue&type=template&id=3ff9422e"
import script from "./releaseCase.vue?vue&type=script&lang=js"
export * from "./releaseCase.vue?vue&type=script&lang=js"
import style0 from "./releaseCase.vue?vue&type=style&index=0&id=3ff9422e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports